import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [units, setUnits] = useState("celsius");
  function showFahrenheits(event) {
    event.preventDefault();
    setUnits("fahrenheit");
  }
  function showCelsius(event) {
    event.preventDefault();
    setUnits("celsius");
  }
  function Fahrenheit() {
    return (props.celsius * 9) / 5 + 32;
  }
  if (units === "celsius") {
    return (
      <div className="degrees">
        {Math.round(props.celsius)}
        <span className="Weather-units">
          °C|
          <a href="/" className="App-link" onClick={showFahrenheits}>
            F°
          </a>
        </span>
      </div>
    );
  } else {
    return (
      <div className="degrees">
        {Math.round(Fahrenheit())}
        <span className="Weather-units">
          <a href="/" className="App-link" onClick={showCelsius}>
            °C
          </a>
          |F°
        </span>
      </div>
    );
  }
}
